'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Flashlight = require('./Flashlight');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Flashlight).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Flashlight/index.js
// module id = 1192
// module chunks = 1